type Order = {
  orderId: string;
  subtotal: string;
  deliveryFee: string;
  total: string;
  currency: string;
};

export function OrderSummary({ order }: { order: Order }) {
  return (
    <div className="bg-[var(--color-accent)]/10 border border-[var(--color-accent)]/30 rounded-xl p-4 my-3">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-[var(--color-accent)]">✓</span>
        <span className="font-medium text-sm text-[var(--color-accent)]">Order Created</span>
        <span className="text-xs text-gray-500 ml-auto">#{order.orderId.slice(0, 8)}</span>
      </div>
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal</span>
          <span>£{order.subtotal}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Delivery</span>
          <span>{order.deliveryFee === "0.00" ? "Free" : `£${order.deliveryFee}`}</span>
        </div>
        <div className="flex justify-between font-bold pt-2 border-t border-[var(--color-accent)]/20">
          <span>Total</span>
          <span>£{order.total}</span>
        </div>
      </div>
    </div>
  );
}
